import { useEffect } from 'react';

export const useScrollLock = (active: boolean) => {
    useEffect(() => {
        if (!active) return;

        const html = document.documentElement;
        const hasVerticalScrollbar = html.scrollHeight > html.clientHeight;

        const prevBodyOverflow = document.body.style.overflow;
        const prevHtmlOverflow = html.style.overflow;
        const prevScrollbarGutter = html.style.scrollbarGutter;

        if (hasVerticalScrollbar) {
            html.style.scrollbarGutter = 'stable';
        }
        document.body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = prevBodyOverflow;
            html.style.overflow = prevHtmlOverflow;
            html.style.scrollbarGutter = prevScrollbarGutter;
        };
    }, [active]);
};
